module.exports = __webpack_public_path__ + "img/title2.66aca238.png";